import React from 'react';
import { motion } from 'framer-motion';
const phases = [{
  week: 'Semana 1',
  title: 'Silencio',
  description: 'Vaciamos el ruido de tu sistema nervioso para que dejes de vivir en alerta.'
}, {
  week: 'Semana 2',
  title: 'Despertar',
  description: 'Re-sensibilizamos tus receptores sensoriales con micro-ejercicios somáticos.'
}, {
  week: 'Semana 3',
  title: 'Magnetismo',
  description: 'Integramos tu nueva vibración corporal en tu vida diaria y tus relaciones.'
}];
export function HowItWorksSection() {
  return <section className="py-12 px-6 bg-cream" data-id="element-75">
      <div className="max-w-4xl mx-auto" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-20" data-id="element-77">
          <h2 className="text-4xl md:text-5xl font-playfair text-burgundy-deep mb-6" data-id="element-78">
            El Camino de Retorno
          </h2>
          <p className="text-lg text-charcoal/70" data-id="element-79">
            Cómo funciona el protocolo de 21 días
          </p>
        </motion.div>

        <div className="relative" data-id="element-80">
          {/* Vertical Line */}
          <div className="absolute left-[27px] md:left-1/2 top-0 bottom-0 w-[1px] bg-gradient-to-b from-gold/20 via-gold to-gold/20 md:-translate-x-1/2" data-id="element-81" />

          <div className="space-y-16" data-id="element-82">
            {phases.map((phase, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} viewport={{
            once: true,
            margin: '-100px'
          }} className={`relative flex flex-col md:flex-row items-start md:items-center gap-8 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-83">
                {/* Center Node */}
                <div className="absolute left-0 md:left-1/2 w-14 h-14 bg-cream border-2 border-gold rounded-full flex items-center justify-center z-10 md:-translate-x-1/2 shadow-md" data-id="element-84">
                  <span className="font-playfair text-xl text-burgundy-deep" data-id="element-85">
                    {index + 1}
                  </span>
                </div>

                {/* Content */}
                <div className={`w-full md:w-1/2 pl-20 md:pl-0 ${index % 2 === 0 ? 'md:text-center' : 'md:text-center md:pr-16'}`} data-id="element-86">
                  <div className={`bg-white p-8 rounded-sm shadow-sm border border-blush-light relative text-center ${index % 2 === 0 ? 'md:ml-16' : ''}`} data-id="element-87">
                    <span className="text-gold uppercase tracking-wider text-sm font-semibold mb-2 block" data-id="element-88">
                      {phase.week}
                    </span>
                    <h3 className="text-2xl font-playfair text-burgundy-deep mb-4" data-id="element-89">
                      {phase.title}
                    </h3>
                    <p className="text-charcoal/80 leading-relaxed" data-id="element-90">
                      {phase.description}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}